import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/sentry";
import { captureAttribution } from "@/lib/attribution";

// Init Sentry as early as possible (no-op if REACT_APP_SENTRY_DSN_FRONTEND is unset)
initSentry();

// Remember which ad brought this visitor (first touch, 30 days)
captureAttribution();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
